import * as React from 'react';
import * as Loadable from 'react-loadable';
import { LoadingSpinner } from '@common/components';

export const AsyncAuthorizationDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/authorization').then(m => m.AuthorizationDetail),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncAuthorizationManageInventory = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/authorization').then(m => m.ManageInventory),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncAuthorizationSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/authorization').then(m => m.AuthorizationSearch),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncInvoicingSearch = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/invoicing').then(m => m.InvoicingSearch),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncInvoiceCreate = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/invoicing').then(m => m.InvoiceEdit),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncInvoiceHeaderCreate = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/invoicing').then(m => m.InvoiceHeaderCreate),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncInvoiceDetails = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/invoicing').then(m => m.InvoiceDetails),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPurchasingSearch = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/purchasing').then(m => m.PurchasingSearch),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPurchasingDetails = Loadable({
  loader: () => import(/* webpackChunkName: "AuthInvoiceModule" */ 'src/purchasing').then(m => m.PurchasingDetails),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});



// WEBPACK FOOTER //
// ./src/_Modules/auth-invoice.module.tsx